<script setup lang="ts">
import GaiaAddButton from '../base/GaiaAddButton.vue';
import GaiaButton from '../base/GaiaButton.vue';
import { gaiaNeutral, gaiaTextButtonOverrides } from '../themes/tokens';

const props = defineProps({
  /** Show the dashed "Add filter" button. */
  canAdd: {
    type: Boolean,
    default: true,
  },
  addLabel: {
    type: String,
    default: 'Add filter',
  },
  /** Show the right-aligned red Reset action. */
  showReset: {
    type: Boolean,
    default: false,
  },
  resetLabel: {
    type: String,
    default: 'Reset',
  },
});

const emit = defineEmits<{ add: []; reset: [] }>();

const border = gaiaNeutral.borderCard;
const bg = gaiaNeutral.surfaceSoft;
</script>

<template>
  <!-- Filter strip from the Entity List template: GaiaFilterChips (default
       slot) + dashed add-filter + red reset. Bespoke container chrome. -->
  <n-flex align="center" :size="8" class="gaia-filter-bar">
    <slot />
    <!-- The add button is slotted so a caller can wrap it in the popover that
         picks the column; the fallback is the plain button. -->
    <slot v-if="props.canAdd" name="add">
      <gaia-add-button variant="dashed" @click="emit('add')">{{ props.addLabel }}</gaia-add-button>
    </slot>
    <gaia-button
      v-if="props.showReset"
      text
      size="small"
      :theme-overrides="gaiaTextButtonOverrides.danger"
      :style="{ marginLeft: 'auto' }"
      @click="emit('reset')"
    >
      {{ props.resetLabel }}
    </gaia-button>
  </n-flex>
</template>

<style scoped>
/* Container chrome only: the soft card the chips sit in. */
.gaia-filter-bar {
  padding: 10px 12px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(bg);
}
</style>
